var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoResults = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 102,
  height: 63
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-15 42.23 4.446)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42.765,
  height: 53.189,
  x: 0.374,
  y: 0.374,
  fill: "#FFF",
  stroke: "#E2DFDB",
  strokeWidth: 0.747,
  rx: 2.241
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EBE8E5",
  stroke: "#E2DFDB",
  strokeWidth: 0.747,
  d: "M.374 37.469h42.765V2.24A1.868 1.868 0 0 0 41.27.374H2.24A1.868 1.868 0 0 0 .374 2.24v35.23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F2EF",
  d: "M2.176 40.887h36.985v4.35H2.176zm0 5.655h20.016v4.35H2.176z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(15 30.652 227.54)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42.765,
  height: 53.189,
  x: 0.374,
  y: 0.374,
  fill: "#FFF",
  stroke: "#E2DFDB",
  strokeWidth: 0.747,
  rx: 2.241
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EBE8E5",
  stroke: "#E2DFDB",
  strokeWidth: 0.747,
  d: "M.374 37.469h42.765V2.24A1.868 1.868 0 0 0 41.27.374H2.24A1.868 1.868 0 0 0 .374 2.24v35.23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F2EF",
  d: "M2.176 40.887h36.985v4.35H2.176zm0 5.655h20.016v4.35H2.176z"
})))));
export default SvgNoResults;